var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common_footer"},[_c('p',[_vm._v("粤ICP 备 07046349号-2 工信部备案管理 | 本网站支持IPv6网络")]),_vm._v(" "),_c('p',[_vm._v("Copyright@2012 国投证券股份有限公司 SDIC SECURITIES Co.LTD.,")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2640703e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/style-rem-loader??ref--1!./src/components/common/footer.vue
// module id = 1391
// module chunks = 2